module.exports = __webpack_public_path__ + "img/middle.287c385e.svg";